import MInput from './src';
import './style';

MInput.install = Vue => {
  Vue.component('MInput', MInput);
};

export default MInput;
